<template>
  <date-time-picker :label="label || title" first-day-of-week="1" :time-format="timeFormat" :time-buttons="timeButtons" v-model="val"></date-time-picker>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import DateTimePicker from '../DateTimePicker';
import moment from 'moment';

export default {
  mixins: [EventMixin],
  components: {DateTimePicker},
  props: {
    value: {
      type: undefined,
      default: () => ({})
    },
    name: String,
    label: String,
    title: String,
    timeFormat: {
      type: String,
      default: "HH:mm"
    },
    defaultValue: {
      type: undefined,
      default: ""
    },
    'time-buttons': {type: Array, default: () => []}
  },
  created() {
    _.set(this.value, this.name, moment(this.val).unix());
    this.$emit("input", this.value);
  },
  computed: {
    val: {
      get () {
        var defaultVal = moment();
        if(this.defaultValue == "start_of_day") {
          defaultVal = defaultVal.startOf("day");
        } else if (this.defaultValue == "end_of_day") {
          defaultVal = defaultVal.endOf("day");
        } else if (this.defaultValue) {
          defaultVal = moment(this.defaultValue);
        }

        return moment.unix(_.get(this.value, this.name, defaultVal.unix())).toDate();
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, moment(val).unix());
        this.$emit("input", value);
      }
    }
  }
}
</script>
